export const QUOTE_REQUEST_TO_OWNER = 'quote_request_to_owner';
export const QUOTE_REQUEST_TO_USER = 'quote_request_to_user';
